/*
  facil. — reveal « blur-in » des TITRES / PHRASES (.reveal-blur).
  À l'entrée dans le viewport (IntersectionObserver) : flou + opacité → net,
  mot par mot avec une légère cascade. Une seule fois par élément.
  Découpe RÉCURSIVE : le texte dans les éléments inline (<strong>, <span class="brand">…)
  est aussi animé en gardant le wrapper (emphase + wordmark participent à la cascade).
  transform / opacity / filter only → zéro layout shift.
*/
(function () {
  var els = document.querySelectorAll('.reveal-blur');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Espaces NORMAUX seuls = séparateurs (les nbsp restent collés). <br> = élément vide préservé.
  function splitInto(parent, target, state) {
    Array.prototype.slice.call(parent.childNodes).forEach(function (node) {
      if (node.nodeType === 3) {
        node.textContent.split(/( +)/).forEach(function (part) {
          if (part === '') return;
          if (/^ +$/.test(part)) {
            target.appendChild(document.createTextNode(part));
          } else {
            var span = document.createElement('span');
            span.className = 'reveal-blur__word';
            span.style.setProperty('--w', state.wi);
            span.textContent = part;
            target.appendChild(span);
            state.wi += 1;
          }
        });
      } else {
        var clone = node.cloneNode(false); // wrapper seul (tag + attributs), sans enfants
        splitInto(node, clone, state); // recurse : remplit le wrapper de mots
        target.appendChild(clone);
      }
    });
  }

  els.forEach(function (el) {
    if (el.dataset.revealReady) return;
    var frag = document.createDocumentFragment();
    splitInto(el, frag, { wi: 0 });
    el.innerHTML = '';
    el.appendChild(frag);
    el.dataset.revealReady = '1';
  });

  // Reduced-motion ou pas d'IO : net immédiat, aucune animation.
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  // Force un reflow : l'état initial (opacity 0 / flou) est commité AVANT is-revealed,
  // pour que l'animation joue aussi sur un titre déjà visible au chargement (ex. H1 hero).
  void document.documentElement.offsetHeight;

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
  );

  els.forEach(function (el) {
    io.observe(el);
  });
})();

/*
  facil. — compteur animé (.count-up) : anime de 0 → data-count-to quand visible.
  data-count-duration (ms, défaut 2000). Une seule fois. reduced-motion = valeur finale directe.
*/
(function () {
  var counters = document.querySelectorAll('.count-up');
  if (!counters.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function run(el) {
    var target = parseInt(el.getAttribute('data-count-to'), 10) || 0;
    if (reduce) {
      el.textContent = target;
      return;
    }
    var dur = parseInt(el.getAttribute('data-count-duration'), 10) || 2000;
    var startTs = null;
    function step(ts) {
      if (startTs === null) startTs = ts;
      var p = Math.min((ts - startTs) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
      el.textContent = Math.round(eased * target);
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target;
      }
    }
    requestAnimationFrame(step);
  }

  if (!('IntersectionObserver' in window)) {
    counters.forEach(run);
    return;
  }

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          run(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );

  counters.forEach(function (el) {
    io.observe(el);
  });
})();

/*
  facil. — STAGGER au scroll (générique, réutilisable). Sur tout conteneur `.js-stagger` :
  à ~20% visible (IntersectionObserver, une seule fois), pose `.js-stagger--in`.
  L'état caché initial (`.js-stagger--ready`) n'est posé QUE si le JS tourne et que
  reduced-motion est OFF → sans JS / reduced-motion, le contenu reste visible.
  Le décalage (cascade) + l'amplitude sont gérés en CSS par la section (--card-i, etc.).
*/
(function () {
  var els = document.querySelectorAll('.js-stagger');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  els.forEach(function (el) {
    el.classList.add('js-stagger--ready'); // état initial caché (CSS)
    void el.offsetHeight;                   // reflow : commit avant la révélation
  });

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('js-stagger--in');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  els.forEach(function (el) {
    io.observe(el);
  });
})();

/*
  facil. — TECHNOLOGIE DU CIL (<alto-tech-accordion>) : accordéon split + autoplay.
  Une seule fonction goTo(i) : pose --active sur l'item i, swap l'unique image (fondu),
  met à jour dots / remplissage de barre / indicateur i/n. Autoplay = requestAnimationFrame
  qui remplit la barre EN CONTINU sur N s (minuteur visuel de l'étape) puis goTo(i+1).
  Interaction = reset du minuteur ; mouseenter = pause, mouseleave = reprise.
  Améliorations : fondu image au swap (opacity), préchargement des images via IO,
  autoplay GATÉ (ne démarre que quand la section est visible → zéro CPU hors écran).
  reduced-motion : pas d'autoplay, accordéon au clic. JS GLOBAL = chargement fiable.
*/
(function () {
  if (!('customElements' in window) || customElements.get('alto-tech-accordion')) return;

  class AltoTechAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(this.querySelectorAll('.alto-tech__item'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.alto-tech__dot'));
      this.img = this.querySelector('.alto-tech__img');
      this.video = this.querySelector('.alto-tech__video');
      this.visual = this.querySelector('.alto-tech__visual');
      this._visible = false; // section visible (IntersectionObserver) → autorise la lecture vidéo
      this.fill = this.querySelector('.alto-tech__fill');
      this.n = this.items.length;
      if (!this.n) return;

      this.i = 0;
      this.playing = false;
      this.userPaused = false;
      this.rafId = null;
      this.elapsed = 0; // temps ÉCOULÉ dans l'étape courante (n'avance que pendant la lecture)
      this._lastFrame = null; // dernier timestamp rAF (null après pause → on ne compte pas le temps en pause)
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.speed = (parseFloat(this.getAttribute('data-autoplay-speed')) || 6) * 1000;
      this.autoplayWanted =
        this.getAttribute('data-autoplay') === 'true' && !this.reduce && this.n > 1;

      this.btnToggle = this.querySelector('[data-tech-toggle]');
      this.btnPrev = this.querySelector('[data-tech-prev]');
      this.btnNext = this.querySelector('[data-tech-next]');
      this.cur = this.querySelector('[data-tech-current]');

      var self = this;

      this.items.forEach(function (it, k) {
        var title = it.querySelector('.alto-tech__title');
        if (title) {
          title.addEventListener('click', function () {
            self.goTo(k);
            self.resetTimer();
          });
        }
      });
      if (this.btnPrev) {
        this.btnPrev.addEventListener('click', function () {
          self.goTo((self.i - 1 + self.n) % self.n);
          self.resetTimer();
        });
      }
      if (this.btnNext) {
        this.btnNext.addEventListener('click', function () {
          self.goTo((self.i + 1) % self.n);
          self.resetTimer();
        });
      }
      if (this.btnToggle) {
        this.btnToggle.addEventListener('click', function () {
          if (self.playing) {
            self.userPaused = true;
            self.pause();
          } else {
            self.userPaused = false;
            self.play();
          }
        });
      }

      // (Pas de pause au survol : elle gelait la barre dès que la souris était sur la section.
      //  Le contrôle manuel ⏸/▶ reste disponible pour mettre en pause volontairement.)

      this.goTo(0);

      // Préchargement des images + autoplay GATÉ sur la visibilité.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              // « Vraiment dans la zone de lecture » = soit ≥ 50 % de la section visible
              // (section plus courte que l'écran), soit la section traverse le CENTRE du
              // viewport (section plus haute que l'écran). Ainsi l'autoplay démarre quand on
              // REGARDE la section (pas dès qu'elle pointe en bas → sinon la barre défile
              // hors-vue) et ne se coupe pas quand elle est centrée.
              var rect = e.boundingClientRect;
              var vh = window.innerHeight || document.documentElement.clientHeight;
              var spansCenter = rect.top <= vh * 0.5 && rect.bottom >= vh * 0.5;
              var visibleEnough = e.intersectionRatio >= 0.5 || spansCenter;
              if (visibleEnough) {
                var wasHidden = !self._visible;
                self._visible = true;
                self.preload();
                // On (re)arrive sur la section : le remplissage repart VISIBLEMENT de 0.
                if (wasHidden) self.resetTimer();
                if (self.autoplayWanted && !self.userPaused) self.play();
                self.playActiveVideo();
              } else {
                self._visible = false;
                self.pause();
                if (self.video) {
                  try { self.video.pause(); } catch (err) {}
                }
              }
            });
          },
          { threshold: [0, 0.25, 0.5, 0.75, 1] }
        );
        io.observe(this);
      } else {
        this._visible = true;
        this.preload();
        if (this.autoplayWanted) this.play();
        this.playActiveVideo();
      }
    }

    // Lance la vidéo de l'étape active (si présente et section visible).
    playActiveVideo() {
      if (!this.video || this.reduce || !this._visible) return;
      var it = this.items[this.i];
      var vsrc = it ? it.getAttribute('data-video-src') : null;
      if (!vsrc) return;
      if (this.video.getAttribute('src') !== vsrc) {
        this.video.src = vsrc;
        this.video.load();
      }
      var p = this.video.play();
      if (p && p.catch) p.catch(function () {});
    }

    goTo(i) {
      this.i = i;
      var self = this;
      this.items.forEach(function (it, k) {
        var on = k === i;
        it.classList.toggle('is-active', on);
        var title = it.querySelector('.alto-tech__title');
        if (title) title.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      this.dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
      });

      var it = this.items[i];
      var vsrc = it ? it.getAttribute('data-video-src') : null;
      // L'étape porte-t-elle une vidéo ? → on affiche la vidéo (prioritaire) ; sinon l'image.
      if (this.visual) this.visual.classList.toggle('is-video', !!vsrc);

      if (vsrc && this.video) {
        // Vidéo : (re)charge la source si besoin, puis lecture si la section est visible.
        if (this.video.getAttribute('src') !== vsrc) {
          this.video.src = vsrc;
          this.video.load();
        }
        if (this._visible && !this.reduce) {
          var pv = this.video.play();
          if (pv && pv.catch) pv.catch(function () {});
        }
      } else {
        // Image : on met la vidéo en pause + fondu de swap (image préchargée → pas de flash).
        if (this.video) {
          try { this.video.pause(); } catch (e) {}
        }
        if (this.img && it && it.getAttribute('data-image-src')) {
          this.img.style.opacity = '0';
          clearTimeout(this._fadeT);
          this._fadeT = setTimeout(function () {
            self.img.src = it.getAttribute('data-image-src');
            self.img.srcset = it.getAttribute('data-image-srcset') || '';
            self.img.alt = it.getAttribute('data-image-alt') || '';
            self.img.style.opacity = '1';
          }, 180);
        }
      }

      if (this.cur) this.cur.textContent = i + 1;
    }

    preload() {
      if (this._preloaded) return;
      this._preloaded = true;
      this.items.forEach(function (it) {
        var src = it.getAttribute('data-image-src');
        if (!src) return;
        var im = new Image();
        var ss = it.getAttribute('data-image-srcset');
        if (ss) im.srcset = ss;
        im.src = src;
      });
    }

    play() {
      if (this.playing || this.userPaused || this.reduce || this.n < 2) return;
      this.playing = true;
      this.setToggle();
      var self = this;
      // Accumulateur DELTA : on additionne (ts - dernière frame). À la reprise après une pause
      // (IntersectionObserver pendant le scroll), _lastFrame est null → aucun temps de pause n'est
      // compté → le remplissage repart pile où il s'était arrêté (plus de saut / blocage / reprise brutale).
      var step = function (ts) {
        if (!self.playing) return;
        if (self._lastFrame == null) self._lastFrame = ts;
        self.elapsed += ts - self._lastFrame;
        self._lastFrame = ts;
        var p = Math.min(self.elapsed / self.speed, 1);
        if (self.fill) self.fill.style.transform = 'translateX(-50%) scaleY(' + p + ')';
        if (p >= 1) {
          self.goTo((self.i + 1) % self.n);
          self.elapsed = 0;
          if (self.fill) self.fill.style.transform = 'translateX(-50%) scaleY(0)';
        }
        self.rafId = requestAnimationFrame(step);
      };
      this.rafId = requestAnimationFrame(step);
    }

    pause() {
      this.playing = false;
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = null;
      this._lastFrame = null; // la prochaine reprise ne comptera pas le temps passé en pause
      this.setToggle();
    }

    // Toute interaction réinitialise le minuteur visuel de l'étape.
    resetTimer() {
      this.elapsed = 0;
      this._lastFrame = null;
      if (this.fill) this.fill.style.transform = 'translateX(-50%) scaleY(0)';
    }

    setToggle() {
      if (this.btnToggle) this.btnToggle.setAttribute('aria-pressed', this.playing ? 'true' : 'false');
      this.classList.toggle('is-playing', this.playing);
    }
  }

  customElements.define('alto-tech-accordion', AltoTechAccordion);
})();

/* ============================================================================
   facil. — ANCRES FIABLES (#section) malgré les images lazy
   ----------------------------------------------------------------------------
   Le navigateur saute à l'ancre AVANT que les images/polices aient réservé leur
   place : la page se recompose ensuite et on atterrit à côté (ex. le lien footer
   « La technologie » qui tombait sur la section UGC). On re-vise donc l'ancre une
   fois le chargement terminé, puis une seconde fois après stabilisation.
   scrollIntoView respecte le scroll-margin-top des sections.
   ============================================================================ */
(function () {
  if (!window.location.hash || window.location.hash.length < 2) return;
  var id = decodeURIComponent(window.location.hash.slice(1));

  function settle() {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ block: 'start', behavior: 'auto' });
  }

  function run() {
    settle();
    setTimeout(settle, 350); // 2e passe : images/polices arrivées
  }

  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run, { once: true });
})();

/* ===========================================================================
   facil. — Bouton à remplissage DIRECTIONNEL (.btn-dir)
   Injecte 4 triangles détecteurs de bord + 4 calques jumeaux (clone du label).
   La géométrie clip-path + le combinateur ~ font tout l'effet au survol (CSS).
   Le label original n'est pas dupliqué côté accessibilité (calques aria-hidden).
   =========================================================================== */
(function () {
  'use strict';

  /* bord d'entrée : 1 haut · 2 droite · 3 bas · 4 gauche (distance minimale au bord) */
  function entryEdge(btn, e) {
    var r = btn.getBoundingClientRect();
    var top = e.clientY - r.top;
    var right = r.right - e.clientX;
    var bottom = r.bottom - e.clientY;
    var left = e.clientX - r.left;
    var min = Math.min(top, right, bottom, left);
    if (min === top) return '1';
    if (min === right) return '2';
    if (min === bottom) return '3';
    return '4';
  }

  function enhance(btn) {
    if (btn.dataset.dirReady) return;

    var label = btn.querySelector('.btn-dir__label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'btn-dir__label';
      Array.prototype.slice.call(btn.childNodes).forEach(function (n) {
        if (n.nodeType === 1 && n.classList && n.classList.contains('loading__spinner')) return;
        label.appendChild(n);
      });
      btn.insertBefore(label, btn.firstChild);
    }

    for (var i = 1; i <= 4; i++) {
      var el = document.createElement('span');
      el.className = 'btn-dir__content';
      el.setAttribute('data-index', i);
      el.setAttribute('aria-hidden', 'true');
      el.appendChild(label.cloneNode(true));
      btn.appendChild(el);
    }

    /* La direction est VERROUILLÉE à l'entrée et figée jusqu'à la sortie :
       mouseenter/mouseleave ne se déclenchent qu'au franchissement du bord du
       bouton (pas sur les mouvements internes) → un seul effet, qui ne suit pas la souris. */
    btn.addEventListener('mouseenter', function (e) {
      btn.setAttribute('data-dir', entryEdge(btn, e));
    });
    btn.addEventListener('mouseleave', function () {
      btn.removeAttribute('data-dir');
    });

    btn.dataset.dirReady = '1';
    btn.classList.add('is-dir-ready');
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.slice.call(scope.querySelectorAll('.btn-dir')).forEach(enhance);
  }

  run(document);
  /* ré-enhancement possible après injection AJAX (ex. cartes cross-sell) */
  window.facilDirButtons = run;
})();

